import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class, _class2, _temp;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { browserHistory } from 'react-router';
import { populateComposebox } from 'redux/modules/composeboxForm';
import { connect } from 'react-redux';
import * as styles from './PostTemplateItem.scss';
import { Composebox, Dotdotdot, FormElements, Popover, PostCard, SocialNetworkIconBar, WatchClickOutside } from 'components';
import { ModalLayout, Navbar } from 'containers';

var getUrls = require('get-urls');

var _ = require('lodash');

var VisibilitySensor = require('react-visibility-sensor');

var PostTemplateItem = (_dec = connect(function (state) {
  var orgId = state.organization.current.id;
  return {
    config: state.config,
    organization: state.organization.current,
    queues: state.queues["".concat(orgId)] || [],
    theme: state.theme
  };
}, {
  populateComposebox: populateComposebox
}), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inherits(PostTemplateItem, _Component);

  var _super = _createSuper(PostTemplateItem);

  function PostTemplateItem(props) {
    var _this;

    _classCallCheck(this, PostTemplateItem);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "hide", function () {
      _this.setState({
        popoverOpen: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "togglePopover", function () {
      var toggleVal = !_this.state.popoverOpen;

      _this.setState({
        popoverOpen: toggleVal
      });

      if (toggleVal) {
        _this.props.setPopover(_assertThisInitialized(_this));
      } else {
        _this.props.removePopover();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "enqueuePost", function (q) {
      var Queue = _.find(_this.props.queues, function (o) {
        return o.id === q.id;
      });

      if (!Queue) {
        return;
      }

      if (_this.props.onShouldQueuePost) {
        _this.props.onShouldQueuePost(Queue.id, _this.props.data.id);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "getInitialValues", function () {
      var images = _this.props.data.PostTemplateS3Files && _this.props.data.PostTemplateS3Files.length && _this.props.data.PostTemplateS3Files[0].S3File ? [_this.props.data.PostTemplateS3Files[0].S3File.fullyQualifiedUrl] : null;
      var postType = 'textPost';
      var link = {};

      if (!images) {
        if (_this.props.data.linkUrl) {
          link.link = _this.props.data.linkUrl;
          link.title = _this.props.data.linkTitle || _this.props.data.title;
          link.image = _this.props.data.linkImagePreview ? _this.props.data.linkImagePreview : null;
          postType = 'linkPost';
        } else {
          var urls = getUrls(_this.props.data.message);

          if (urls) {
            var l = Array.from(urls)[0];

            if (l) {
              link.link = l;
              link.title = _this.props.data.title;
              postType = 'linkPost';
            }
          }
        }
      } else {
        postType = 'imagePost';
      }

      var messagesData = {};
      _this.props.data.SocialAccountPostTemplates && _this.props.data.SocialAccountPostTemplates.length > 0 ? _this.props.data.SocialAccountPostTemplates.forEach(function (sapt) {
        messagesData[sapt.accountPlatform.toLowerCase()] = sapt.message;
      }) : null;
      return {
        messages: _objectSpread({
          global: _this.props.data.message
        }, messagesData),
        images: images,
        postType: postType,
        linkData: link
      };
    });

    _defineProperty(_assertThisInitialized(_this), "getSocialNetworks", function () {
      var socialNetworks = new Set();

      if (_this.props.data.SocialAccountPostTemplates) {
        _this.props.data.SocialAccountPostTemplates.forEach(function (account) {
          try {
            socialNetworks.add(account.accountPlatform.split(' ')[0].toLowerCase());
          } catch (e) {
            return [];
          }
        });
      }

      return /*#__PURE__*/React.createElement(SocialNetworkIconBar, {
        networks: socialNetworks,
        style: {
          position: 'absolute',
          bottom: 8,
          left: 8
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleScheduleClick", function () {
      var translatedPost = _this.getInitialValues();

      _this.props.populateComposebox(translatedPost, _this.props.organization.id);

      browserHistory.push({
        pathname: "/org/".concat(_this.props.organization.id, "/compose"),
        state: {
          modal: false
        }
      });
    });

    _this.state = {
      popoverOpen: false,
      visibilitySensor: false
    };
    return _this;
  }

  _createClass(PostTemplateItem, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      if (this.props.isVisible !== nextProps.isVisible) {
        return true;
      }

      if (this.state.visibilitySensor !== nextState.visibilitySensor) {
        return true;
      }

      if (this.state.popoverOpen !== nextState.popoverOpen) {
        return true;
      }

      return false;
    }
  }, {
    key: "render",
    value: function render() {
      var imgFromLink = false;
      var postImage = this.props.data.PostTemplateS3Files && this.props.data.PostTemplateS3Files.length && this.props.data.PostTemplateS3Files[0].S3File ? this.props.data.PostTemplateS3Files[0].S3File.fullyQualifiedUrl : null;

      if (!postImage && this.props.data.linkImagePreview) {
        postImage = "".concat(this.props.data.linkImagePreview);
        imgFromLink = true;
      }

      var boxStyleObj = {
        backgroundImage: postImage ? "url(\"".concat(postImage).concat(imgFromLink ? '' : '.thumb', "\"), url(\"").concat(postImage, "\")") : null
      };
      var boxInner = postImage ? null : /*#__PURE__*/React.createElement("div", {
        className: styles.boxInner
      }, /*#__PURE__*/React.createElement(Dotdotdot, {
        clamp: 2,
        style: {
          margin: '10px 0'
        }
      }, /*#__PURE__*/React.createElement("h2", {
        className: styles.boxHeadline
      }, this.props.data.title.replace('Twitter Only:', '').trim())), /*#__PURE__*/React.createElement(Dotdotdot, {
        clamp: 5
      }, /*#__PURE__*/React.createElement("h6", {
        className: styles.boxDescription
      }, this.props.data.message)));
      var queueChoices = this.props.queues ? this.props.queues.map(function (q) {
        return {
          id: q.id,
          title: q.SocialAccounts && !!q.SocialAccounts.length ? q.SocialAccounts[0].username : 'Queue'
        };
      }) : [];
      var cardActions = this.props.config.features.showQueue ? [/*#__PURE__*/React.createElement(FormElements.LLDropDownList, {
        theme: this.props.theme,
        label: "Queue",
        items: queueChoices,
        onChange: this.enqueuePost
      }), /*#__PURE__*/React.createElement(FormElements.LLButton, {
        onClick: this.handleScheduleClick,
        label: "Schedule",
        style: {
          marginTop: '11px'
        }
      })] : [/*#__PURE__*/React.createElement(FormElements.LLButton, {
        onClick: this.handleScheduleClick,
        label: "Schedule",
        style: {
          marginTop: '11px'
        }
      })];
      var popoverContent = /*#__PURE__*/React.createElement(WatchClickOutside, {
        onClickOutside: this.props.removePopover
      }, /*#__PURE__*/React.createElement(PostCard, {
        post: {
          imageUrl: postImage,
          title: this.props.data.title,
          message: this.props.data.message,
          isBoostable: this.props.data.isBoostable,
          SocialAccountPostTemplates: this.props.data.SocialAccountPostTemplates
        },
        actions: cardActions,
        size: 250,
        onClose: this.props.removePopover,
        linkify: true
      }));
      var networkIcons = this.getSocialNetworks();
      return /*#__PURE__*/React.createElement("div", null, this.props.isVisible ? /*#__PURE__*/React.createElement(Popover, {
        open: this.state.popoverOpen,
        content: popoverContent
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.box,
        style: boxStyleObj,
        onClick: this.togglePopover
      }, boxInner, /*#__PURE__*/React.createElement("div", {
        className: styles.networkIconsWrap
      }, networkIcons))) : /*#__PURE__*/React.createElement("div", {
        className: styles.box,
        style: {
          backgroundColor: 'silver'
        }
      }));
    }
  }]);

  return PostTemplateItem;
}(Component), _defineProperty(_class2, "propTypes", {
  data: PropTypes.object.isRequired,
  setPopover: PropTypes.func.isRequired,
  removePopover: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired
}), _temp)) || _class);
export { PostTemplateItem as default };